/**
 * ⟦C62 · lot tableau · A-179⟧ **La création de partie limpide** (friction n° 10 de l'audit du 21/10/2026).
 *
 * Matt : *« Il faut que le jeu soit simple et limpide. »* L'étape ③ de la création posait Mode, « Où vit ta
 * partie » et Graine : la DERNIÈRE chose avant de jouer, et la seule fois où le jeu demande un avis technique à
 * un joueur qui n'a encore rien vu. « Graine » et « Compte » n'ont de sens que pour Matt ou un testeur.
 *
 * Réglage de contenu (`content/meta.json → creation_limpide`, défaut éteint = la création d'avant, au caractère
 * près ⟦A-10⟧). Allumé, l'étape ③ ne pose plus rien : des DÉFAUTS SILENCIEUX et un lien « Options » discret qui
 * rouvre les trois choix d'avant, tels quels.
 *
 * ## Les défauts silencieux, et pourquoi
 *
 *  - **Mode : Normal.** Un game over laisse reprendre, on apprend en tombant. Le hardcore (une seule vie,
 *    +20 % de risque) est un choix de joueur aguerri : il vit derrière « Options », avec sa confirmation.
 *  - **Où vit la partie : la partie locale (bac à sable), SAUF si le joueur a déjà choisi le compte.** C'est le
 *    monde le plus simple pour un débutant : aucun compte à créer, aucun mot de passe, aucun serveur, la partie
 *    démarre en un clic et marche hors ligne. Le compte demande une inscription avant la première image. Ce que
 *    la partie locale ne fait pas (suivre les appareils, graver une victoire en base, rendre le hardcore
 *    vraiment définitif) se lit dans « Options » ; et le monde déjà choisi n'est JAMAIS changé en silence : un
 *    joueur revenu avec son compte continue sur son compte.
 *  - **Graine : au hasard.** Le champ n'existe que pour rejouer une partie à l'identique.
 *
 * Pur : aucune I/O, aucune horloge. Le rendu est dans `NouvelleRun.tsx`.
 */

import { contenu } from "../../game/content";

/** La création limpide est-elle active ? (`content/meta.json → creation_limpide`, absent ⇒ `false`.) */
export function creationLimpide(): boolean {
  return contenu().meta.creation_limpide === true;
}

/**
 * Faut-il poser Mode, « Où vit ta partie » et Graine à l'étape ③ ? Création d'avant (`limpide` faux) : toujours.
 * Création limpide : seulement une fois « Options » ouvert, et il reste ouvert (jamais refermé sur un réglage
 * que le joueur aurait changé : un Hardcore caché serait un piège).
 */
export function reglagesVisibles(limpide: boolean, optionsOuvertes: boolean): boolean {
  return !limpide || optionsOuvertes;
}

/**
 * La réplique de Matt à l'étape ③ quand elle ne pose plus de réglage (« Dernier réglage avant de filmer. »
 * serait faux : il n'y en a plus). Espace insécable avant `?`, comme les trois autres (⟦A-145 · C20, §1 bis⟧).
 */
export const REPLIQUE_PRET_A_FILMER = "Tout est prêt. On tourne ?";

/** Le libellé de l'étape ③ (fil d'étapes, lecteur d'écran) : « Les réglages » n'a plus de réglage à montrer. */
export const LABEL_PRET_A_FILMER = "Prêt à filmer";
